var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fixed":"","left":"","bottom":"","loading":false,"color":"white","id":"lang-button","rounded":_vm.$vuetify.breakpoint.smAndDown,"disabled":_vm.getBotLanguages.length <= 1},on:{"click":_vm.changeLang}},[_c('span',{staticStyle:{"color":"#050038"}},[_vm._v(_vm._s(_vm.current_lang_code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }